export async function batchUploadFiles(files, handler, onFileUpload, onFileFail) {
    const success = [];
    const failed = [];
    await Promise.allSettled(files.map((file) => handler(file)
        .then((result) => {
        const item = { result, file };
        success.push(item);
        onFileUpload === null || onFileUpload === void 0 ? void 0 : onFileUpload(item);
    }, (error) => {
        const item = { error, file };
        failed.push(item);
        onFileFail === null || onFileFail === void 0 ? void 0 : onFileFail(item);
    })
        .catch(console.error)));
    return { success, failed };
}
